import { FC, useEffect, useState } from "react";
import AnimationContainer from "components/Reusable/AnimationContainer/AnimationContainer.js";
import Progressbar from "components/Reusable/Progressbar/Progressbar.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { mediumPassRegex, strongPassRegex } from "helpers/validators.js";

interface IPasswordStrengthEnum {
  [key: string]: {
    regex?: RegExp;
    color: string;
    width: string;
    constKey: string;
  };
}

export const passwordStrengthEnum: IPasswordStrengthEnum = {
  weak: {
    color: "#F44336",
    width: "25",
    constKey: "field-validation-password-weak",
  },
  medium: {
    color: "#febb29",
    width: "75",
    constKey: "field-validation-password-medium",
    regex: mediumPassRegex,
  },
  strong: {
    regex: strongPassRegex,
    color: "#4CAF50",
    width: "100",
    constKey: "field-validation-password-strong",
  },
};

interface IPasswordStrengthProps {
  fieldControls: any;
  password: string;
  passwordStrengthLevel: string;
  setPasswordStrengthLevel: (level: string) => void;
}

const PasswordStrength: FC<IPasswordStrengthProps> = ({
  fieldControls,
  password,
  passwordStrengthLevel,
  setPasswordStrengthLevel,
}) => {
  const { getTextByKey } = useContent();

  useEffect(() => {
    fieldControls.onChange(password);
    if (password?.length > 0) {
      if (passwordStrengthEnum.strong.regex?.test(password)) {
        setPasswordStrengthLevel("strong");
      } else if (passwordStrengthEnum.medium.regex?.test(password)) {
        setPasswordStrengthLevel("medium");
      } else {
        setPasswordStrengthLevel("weak");
      }
    } else {
      setPasswordStrengthLevel("weak");
    }
  }, [password]);

  return (
    <AnimationContainer
      animationClassName={"height-in"}
      animationOn={password?.length > 0}
    >
      <div className={"password-strength-section"}>
        {getTextByKey(passwordStrengthEnum[passwordStrengthLevel].constKey)}
        <Progressbar
          completed={passwordStrengthEnum[passwordStrengthLevel].width}
          color={passwordStrengthEnum[passwordStrengthLevel].color}
          height={"5px"}
        />
      </div>
    </AnimationContainer>
  );
};

export default PasswordStrength;
